import HomeCompact from "./HomeCompact";

export default function Home() {
  return <HomeCompact />;
}
